import { useMemo } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

interface ShopFnbFacilityCarouselCountProps {
    contrast: boolean;
    page: number;
    totalPage: number;
    tabIndex: number;
    id?: string;
}

const ShopFnbFacilityCarouselCount = ({ contrast, page, totalPage, tabIndex, id = '' }: ShopFnbFacilityCarouselCountProps) => {
    const { t } = useTranslation();

    const countClassname = useMemo(() => {
        return clsx(styles['count'], contrast ? styles['count__contrast'] : '');
    }, [contrast]);

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
            id={id}
            data-region-nav
            className={countClassname}
            tabIndex={tabIndex}
            data-interactive
            aria-label={t('shop.pagination_desc', { page, total: totalPage })}
        // onMouseDown={(e) => e.preventDefault()}
        >
            <span className={clsx('number', styles['count__page'])}>{page}</span>
            <span className={clsx('number', styles['count__slash'])}>/</span>
            <span className={clsx('number', styles['count__total'])}>{totalPage}</span>
        </div>
    );
};

export default ShopFnbFacilityCarouselCount;
